/**
 * sl-opil.7.1: React hooks for credit balance queries.
 */
import { useQuery } from '@affine/core/components/hooks/use-query';
import { creditBalanceQuery, creditPacksQuery } from '@affine/graphql';

const NON_BLOCKING_QUERY = {
  suspense: false,
  shouldRetryOnError: false,
} as const;

export function useCreditBalance(
  workspaceId: string,
  workspaceFlavour?: string
) {
  const isLocal = workspaceFlavour === 'local';
  const { data, isLoading, error, mutate } = useQuery(
    isLocal
      ? undefined
      : { query: creditBalanceQuery, variables: { workspaceId } },
    NON_BLOCKING_QUERY
  );

  return {
    balance: isLocal ? null : (data?.creditBalance ?? null),
    isLoading: isLocal ? false : isLoading,
    error: isLocal ? null : error,
    refresh: mutate,
  };
}

export function useCreditPacks() {
  const { data, isLoading, error } = useQuery(
    {
      query: creditPacksQuery,
    },
    NON_BLOCKING_QUERY
  );

  return {
    packs: data?.creditPacks ?? [],
    isLoading,
    error,
  };
}
